import { render, staticRenderFns } from "./channelsAction.vue?vue&type=template&id=53d917b0&"
import script from "./channelsAction.vue?vue&type=script&lang=js&"
export * from "./channelsAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports